import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupEvent } from '../Types';

const RESOURCE = 'repeating-events';

interface IGetRepeatingGroupEvent extends Omit<IUri, 'resource'> {
  id: string;
  token?: string;
}
interface IGetRepeatingGroupEventResponse extends IHttpResponse {
  body?: IGroupEvent;
}
export default async function ({
  token,
  ...buildUrlProps
}: IGetRepeatingGroupEvent): Promise<IGetRepeatingGroupEventResponse> {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    ...buildUrlProps,
  });

  return BaseService.Get({
    url,
    token,
    skipTimestamp: true,
  });
}
